import { useSearchParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { api } from "../api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const email = params.get("email");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setMsg("Passwords do not match.");
      return;
    }

    try {
      const res = await api.resetPassword({
        email,
        password,
      });

      setMsg(res.message);

      if (res.status === "success") {
        setTimeout(() => {
          navigate("/");
        }, 1500);
      }
    } catch (err) {
      setMsg("Unable to reset password.");
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h2>Reset Password</h2>

        <p>Email: {email}</p>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="New Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />

          <button type="submit">Update Password</button>
        </form>

        {msg && <p>{msg}</p>}
      </div>
    </div>
  );
}